import { render } from "./BudgetTemplateUpdate.vue?vue&type=template&id=da27c7b8&scoped=true"
import script from "./BudgetTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./BudgetTemplateUpdate.vue?vue&type=script&lang=js"

import "./BudgetTemplateUpdate.vue?vue&type=style&index=0&id=da27c7b8&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da27c7b8"]])

export default __exports__